// extracted by mini-css-extract-plugin
module.exports = {"Avator":"Avator_Avator__3ucxi","UserIcon":"Avator_UserIcon__2EUI6","LightBG":"Avator_LightBG__1GgCO"};